import { AirSpaceBoundaryCoordinatePoint } from './air-space-boundary-coordinate-point';

export interface AirSpaceBoundaryVertexLine {
    id:string,
    endPoint : AirSpaceBoundaryCoordinatePoint,
    endPointId : number,
    startPoint : AirSpaceBoundaryCoordinatePoint,
    startPointId : number,
    isstraightleg : boolean,
    sequencenumber : number,
    isselected : boolean,
    ismodified : boolean
}

export class AirSpaceBoundaryVertexLineModel implements AirSpaceBoundaryVertexLine {
  id:string;
  endPoint : AirSpaceBoundaryCoordinatePoint;
  endPointId : number;
  startPoint : AirSpaceBoundaryCoordinatePoint;
  startPointId : number;
  isstraightleg : boolean = true;
  sequencenumber : number;
  isselected : boolean;
  ismodified : boolean = false;
}

